export default __webpack_public_path__ + "assets/img_mock-678a4250.png";